import PropTypes from 'prop-types';
import { Box, Grid, Typography } from '@mui/material';
import Link from '../../components/Link';

const Column = ({ header, handleLinkClick, children }) => (
  <Grid item xs={12} md={6} display="flex" flexDirection="column" mb={{ xs: 2, md: 0 }}>
    <Typography variant="h4" color="gray.900" component="h2" textTransform="uppercase" mb={5}>
      {header}
    </Typography>
    <Box flexGrow={1}>{children}</Box>
  </Grid>
);

Column.propTypes = {
  header: PropTypes.string.isRequired,
  children: PropTypes.node,
  handleLinkClick: PropTypes.func.isRequired,
};

export default Column;
